<template>
	<v-sheet>
		<slot> </slot>
		<v-navigation-drawer v-model="drawer" absolute temporary right width="100%">
			<order-summary-sale />
		</v-navigation-drawer>
	</v-sheet>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OrderSummarySale from '../saleLayout/OrderSummarySale.vue';
export default {
	components: {
		'order-summary-sale': OrderSummarySale
	},
	data() {
		return {
			drawer: null
		};
	},
	methods: {
		...mapActions(['HIDE_SIDE_NAV', 'SHOW_SIDE_NAV'])
	},
	computed: {
		...mapGetters(['getIsActiveSideNav'])
	},
	watch: {
		drawer(val) {
			if (val === true && this.getIsActiveSideNav === false) {
				this.SHOW_SIDE_NAV();
			}
			if (val === false && this.getIsActiveSideNav === true) {
				this.HIDE_SIDE_NAV();
			}
		},
		getIsActiveSideNav(val) {
			this.drawer = val;
		}
	}
};
</script>

<style></style>
